import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { motion } from 'framer-motion';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PersonIcon from '@mui/icons-material/Person';
import ProductCard from './ProductCard';

const Message = ({ message, onBuyClick }) => {
    const isBot = message.sender === 'bot';

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    p: 3,
                    bgcolor: isBot ? 'transparent' : 'action.hover',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Avatar
                    sx={{
                        bgcolor: isBot ? 'secondary.main' : 'primary.main',
                        width: 32,
                        height: 32,
                    }}
                >
                    {isBot ? <SmartToyIcon fontSize="small" /> : <PersonIcon fontSize="small" />}
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        {isBot ? 'Catchinsta Bot' : 'You'}
                    </Typography>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                        {message.text}
                    </Typography>

                    {message.type === 'product-card' && message.product && (
                        <Box sx={{ mt: 2 }}>
                            <ProductCard product={message.product} onBuyClick={onBuyClick} />
                        </Box>
                    )}
                </Box>
            </Box>
        </motion.div>
    );
};

export default Message;
